import * as React from 'react';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import SkillSetCards from 'bundles/program-home/components/multiprogram/SkillSetCards';

import _t from 'i18n!nls/program-home';

type Props = {
  showSkillSetRoleFilter: boolean;
  programId: string;
  programSlug: string;
  showSkillSets?: () => void;
  skillSetLength?: number;
  enableC4CAcademicDisciplines?: boolean;
  academicDisciplineName?: string;
};

const SkillSetCardsNotConfigurable = ({
  showSkillSetRoleFilter,
  programId,
  programSlug,
  showSkillSets,
  skillSetLength,
  enableC4CAcademicDisciplines,
  academicDisciplineName,
}: Props) => {
  return (
    <PageGridContainer data-testid="enterprise-skill-sets-module">
      <Grid item xs={12}>
        <SkillSetCards
          showSkillSetRoleFilter={showSkillSetRoleFilter}
          programId={programId}
          programSlug={programSlug}
          showSkillSets={showSkillSets}
          title={
            enableC4CAcademicDisciplines && academicDisciplineName
              ? _t('SkillSets for the most popular roles in #{academicDisciplineName}', { academicDisciplineName })
              : _t('SkillSets recommended by your organization')
          }
          skillSetLength={skillSetLength}
          isAnAcademicDisciplineProgram={Boolean(enableC4CAcademicDisciplines)}
        />
      </Grid>
    </PageGridContainer>
  );
};

export default SkillSetCardsNotConfigurable;
